module.exports = __webpack_public_path__ + "img/2.6ee77607.png";